/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';

import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import history from '../assets/history.png';
import {
  ImageSection,
  Img,
  StyledContainer,
  Text,
  Title,
  TwoColumnsContainer,
} from '../ui';

const HistorySection = styled(ImageSection)`
  @media ${laptopAndAbove} {
    background-image: url(${history});
  }
`;

export const History = () => {
  const { up: isLaptop } = useScreenSize('laptop');

  return (
    <>
      {!isLaptop && <Img src={history} alt="Sorare's history" />}
      <HistorySection vAlignContent="center">
        <StyledContainer>
          <TwoColumnsContainer image="left">
            {isLaptop && <div />}
            <div>
              <Title>Sorare's history</Title>
              <Text>
                Founded in 2018, Sorare was created by football fans for
                football fans – and in short order has partnered with the
                globe's biggest football clubs (300-plus) while amassing more
                than 5 million Managers across nearly every country in the
                world. In 2022, Sorare expanded into baseball and basketball via
                exclusive partnerships with MLB and the NBA, respectively.
              </Text>
            </div>
          </TwoColumnsContainer>
        </StyledContainer>
      </HistorySection>
    </>
  );
};
